/* eslint-disable arrow-body-style */
/* eslint-disable padding-line-between-statements */
/* eslint-disable no-underscore-dangle */
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import React, { useState, useEffect, useRef } from 'react';

import htmlParser from 'html-react-parser';
import PropTypes from 'prop-types';
import appConfig from 'app-config';
import { useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { useTranslator } from '@jutro/locale';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { MLModifierUtil, MLLocalDateUtil } from 'ml-portals-util-js';
import '@xengage/gw-platform-translations';
import _ from 'lodash';
import metadata from './MLModifierComponent.metadata.json5';
import styles from './MLModifierComponent.module.scss';
import messages from './MLModifierComponent.messages';

// ML: MLModifierDeirectiveCtrl.js, ml-modifier.html

// US798551 PA Validate Info Enhancement - only show Home, Renters and Condo policy for question Do you currently have any other policies with us?
// codeIdentifier_ML
const FILTERED_LINE_MODIFIERS = [
    'PAMulitplePolicyMobilePolicy_ML', 'PAMulitplePolicyLandlordPolicy_ML', 'PAMulitplePolicyLandlordCondoPolicy_ML',
    'PAMulitplePolicyBoatPolicy_ML', 'PAMulitplePolicyUmbrellaPolicy_ML', 'PAMultiplePolicyOtherProducts_ML'
];
const PA_MULTI_POLICY_CODE_IDENTIFIER = 'PAEvaluationMultiPolicy_ML';
const HO_MULTI_POLICY_CODE_IDENTIFIER = 'HOPMultiPolicyExists_Ext';
const FILTERED_SIGNAL_FROM_DRIVER_SCREEN = ["PADriverSignalProgramPhoneNumber_Ext", "PADriverSignalProgramTCPA_Ext", "PADriverSignalProgramContact_Ext"]
const DISPLAY_SIGNAL_QUESTIONS = ["PADriverSignalProgram_Ext", "PADriverSignalProgramPhoneNumber_Ext", "PADriverSignalProgramTCPA_Ext", "PADriverSignalProgramContact_Ext"]
const isQnB = appConfig.portalCode === 'QB';

function MLModifierComponent(props) {
    const translator = useTranslator();
    const {
        modifier,
        driverModifiers,
        updateModifier,
        isHomeowners,
        isCompRaterSpacing,
        isFieldDefaultedByHvq,
        showValidationErrors,
        onValidate,
        modifierIdToAppend,
        isCompRaterFilterModifiers,
        handleOnChange,
        submissionVM,
        updateWizardData,
        driverPage = false,
        isPolicyChange = false,
        isVehicleModifiers,
        isAdditionalInfoPrebind=false
    } = props;

    const appendModifierId = modifierIdToAppend || '';
    const [dateValidationMessage, setDateValidationMessage] = useState();
    const { refreshData } = useDataRefresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const utilityArray = ['HOPPlumbingYearUpdated_ML', 'HOPElectricalYearUpdated_ML', 'HOPHeatingYearUpdated_ML'];
    // a list of date type modifiers to be shown as MM/YYYY format
    const monthYearMods = ['PADriversRoleModiferPreventionCourseDate_ML'];
    // a list of date type modifiers to be shown as MM/DD/YYYY
    const fullDateMods = ['HOPHomePurchaseDate_Ext', 'HOPIBHSCertDate_ext', 'HOPWildfireCertDate_Ext'];

    const connectedCarModifiers = ["PAConnectedCar_ML", "PAConnectedCarConsentAuthorization_Ext"];
    const isModernProduct = _.get(submissionVM, "isModernProduct_Ext.value", false);
    const isModernProductHOP = isModernProduct && isHomeowners;
    const OPTIONAL_POLICY_NUMBER_MODIFIERS = [
    'PAMultiplePolicyHomePolicyNumber_ML',
    'PAMultiplePolicyRentersPolicyNumber_ML',
    'PAMultiplePolicyCondoPolicyNumber_ML',
    'PAMultiplePolicyMobilePolicyNumber_ML',
    'PAMultiplePolicyLandlordPolicyNumber_ML',
    'PAMultiplePolicyLandlordCondoPolicyNumber_ML',
    'PAMultiplePolicyBoatPolicyNumber_ML',
    'PAMultiplePolicyUmbrellaPolicyNumber_ML',
    'PAMulitplePolicyMotorCyclePolicyNumber_Ext',
    'PAMulitplePolicyRecreationalVehPolicyNumber_Ext',
    'PAMulitplePolicyOffRoadVehPolicyNumber_Ext',
    'HOPMultiPolicyNumberAuto_Ext',
    'HOPAnotherPrimSeasSecPropertyPolicyNumber_Ext',
    'HOPPrimSeasSecPropertyPolicyNumber_Ext',
    'HOPMultiPolicyNumberLandlord_Ext',
    'HOPMultiPolicyNumberUmbrella_Ext',
    'HOPMultiPolicyNumberBoat_Ext',
    'HOPMultiPolicyNumberMotorcycle_Ext',
    'HOPMultiPolicyNumberRecreationalVehicle_Ext',
    'HOPMultiPolicyNumberOffRoadVehicle_Ext'
];

    const signalDiscountPhoneNumberQBRef = useRef(false);
    const isMonthYearModifier = (mod) => {
        return monthYearMods.includes(mod.codeIdentifier_ML.value);
    };
    const isModernProductQB = _.get(submissionVM, "isModernProduct_Ext.value", false);

    const isFullDateModifier = (mod) => {
        return fullDateMods.includes(mod.codeIdentifier_ML.value);
    };

    const _updateModifier = (value, mod) => {
        if (mod.valueType.value !== 'date') {
            mod.chosenTermValue.value = value;
        } else {
            mod.value.dateValue_ML = value;
        }

        mod.updated.value = true;
        if (updateModifier) {
            updateModifier(mod);
        }
    };

    useEffect(() => {
        if (isQnB && !signalDiscountPhoneNumberQBRef.current && window.location.pathname.includes('/additional-information-prebind')) {
            const driversVM = _.get(submissionVM, 'lobData.personalAuto.coverables.drivers');

            const driversData = _.get(submissionVM, 'lobData.personalAuto.coverables.drivers.value', []);

            const pniDriverID = _.get(submissionVM, 'baseData.primaryNamedInsured_ML.publicID.value', '');

            const pniPhoneNumber = _.get(submissionVM, 'baseData.primaryNamedInsured_ML.homeNumber.value', '');

            const pniDriver = driversData.find(
                (driver) => driver?.person?.publicID === pniDriverID
            );

            const phoneNumberModifier = pniDriver?.driverModifiers_ML?.modifiers?.find(
                (modifier) => modifier?.codeIdentifier_ML === 'PADriverSignalProgramPhoneNumber_Ext'
            );

            const pniDriverIndex = driversData.indexOf(pniDriver);

            const pniDriverVM = pniDriverIndex >= 0 ? driversVM?.getElement(pniDriverIndex) : undefined;

            const modifiersVM = pniDriverVM?.driverModifiers_ML?.modifiers;

            const phoneNumberModifierIndex = pniDriver?.driverModifiers_ML?.modifiers?.indexOf(phoneNumberModifier) ?? -1;

            const phoneNumberModifierVM = phoneNumberModifierIndex >= 0 ? modifiersVM?.getElement(phoneNumberModifierIndex) : undefined;

            const chosenTermValue = phoneNumberModifierVM?.chosenTermValue?.value;

            if (phoneNumberModifierVM && (_.isNil(chosenTermValue) || chosenTermValue === '' || chosenTermValue === 'null') ) {
                signalDiscountPhoneNumberQBRef.current = true;

                phoneNumberModifierVM.chosenTermValue.value = pniPhoneNumber;

                const unmaskedPhoneNumberQB = pniPhoneNumber.replace(/[^\d]/g, '');

                if (/^\d{10}$/.test(unmaskedPhoneNumberQB)) {
                    _updateModifier(unmaskedPhoneNumberQB, phoneNumberModifierVM);
                }
                refreshData();
            }
        }
    }, [isQnB, submissionVM, updateWizardData]);

    const updateTextModifier = (event, mod) => {
        mod.model.value.updated = true;
        if (updateModifier) {
            updateModifier(mod.model);
        }

        setTimeout(()=> { event.relatedTarget.focus()}, 0)
    };

    const getDateValidationMessage = (unmaskedDateObject, mod) => {
        const today = MLLocalDateUtil.date2LocalDate(new Date());
        const isCourseDateModifier = [
            'PADefensiveDriverCourseCompleteDate_Ext',
            'PADriversRoleModiferPreventionCourseDate_ML'
        ].includes(mod.value.codeIdentifier_ML);
        const enteredYear = Number(unmaskedDateObject.year);
        const enteredMonth = Number(unmaskedDateObject.month);
        const currentYear = Number(today.year);
        const currentMonth = Number(today.month);
        const isFutureDate = enteredYear > currentYear ||
        (
            enteredYear === currentYear &&
            enteredMonth > currentMonth
        );
        if (isCourseDateModifier && isFutureDate && isQnB) {
        setDateValidationMessage(translator(messages.invalidFutureDate));
    } else if (!utilityArray.includes(mod.value.codeIdentifier_ML) && (unmaskedDateObject.year <= today.year - 3 || unmaskedDateObject.year > today.year)) {
            setDateValidationMessage(translator(messages.invalidYear));
        } else if (unmaskedDateObject.month > 11 || unmaskedDateObject.month < 0) {
            setDateValidationMessage(translator(messages.invalidMonth));
        } else {
            setDateValidationMessage(undefined);
            _updateModifier(unmaskedDateObject, mod)
        }
        refreshData();
    };

    const validateDateModIfShowErrors = (mod) => {
        const today = MLLocalDateUtil.date2LocalDate(new Date());
        if (!utilityArray.includes(mod.value.codeIdentifier_ML) && (mod.value?.dateValue_ML?.year <= today.year - 3 || mod.value?.dateValue_ML?.year > today.year)) {
            setDateValidationMessage(translator(messages.invalidYear));
        } else if (mod.value?.dateValue_ML?.month > 11 || mod.value?.dateValue_ML?.month < 0) {
            setDateValidationMessage(translator(messages.invalidMonth));
        }
    }

    const onDateTextValueChange = (value, mod) => {
        const dateArray = value.split("/")
        const updatedDateArray = dateArray.map((date) => {
            return date.replace(/[^\d]/g, '');
        })

        if (updatedDateArray) {
            const unmaskedDateObject = {
                year: updatedDateArray[1],
                month: updatedDateArray[0],
                day: 1
            };
            const unmaskedYearLength = unmaskedDateObject.year ? unmaskedDateObject.year.length : 0;
            const unmaskedMonthLength = unmaskedDateObject.month ? unmaskedDateObject.month.length : 0;
            const totalUnmaskedLength = unmaskedYearLength + unmaskedMonthLength
            if (totalUnmaskedLength === 6) {
                unmaskedDateObject.month = (parseInt(unmaskedDateObject.month) - 1).toString()
                mod.dateValue_ML.value = unmaskedDateObject;
                getDateValidationMessage(unmaskedDateObject, mod);
            } else if (totalUnmaskedLength === 0) {
                mod.dateValue_ML.value = undefined
                setDateValidationMessage(undefined);
            } else {
                const maskDateObject = {
                    year: dateArray[1],
                    month: dateArray[0],
                    day: 1
                }
                setDateValidationMessage(undefined);
                mod.dateValue_ML.value = maskDateObject;
            }

            mod.updated.value = true;
            refreshData();
        }

    };

    const datetoStringDate = (date) => {
        if (date && date.month !== '') {
            const month = _.get(date, "month", "").toString();
            const year = _.get(date, "year", "").toString();
            const unmaskedYear = year.replace(/[^\d]/g, '');
            if (unmaskedYear.length === 4) {
                if (!month.includes("_")) {
                    const monthInt = parseInt(month);
                    if (monthInt < 9) {
                        return `0${monthInt + 1}/${year}`;
                    }
                    return `${monthInt + 1}/${year}`;
                }
            }
            return `${month}/${year}`
        }
        return ""
    };

    const onPhoneTextValueChange = (value, mod) => {
        const unmaskedPhoneNumber = value.replace(/[^\d]/g, '');
        if (unmaskedPhoneNumber.match(/^\d{10}$/)) {
            _updateModifier(unmaskedPhoneNumber, mod);
        } else {
            mod.chosenTermValue.value = unmaskedPhoneNumber;
            mod.updated.value = true;
            refreshData();
        }
    };

    const filterUtilityModifiers = () => {
        let modifiersToDisplay
        if(_.isEmpty(modifier.value) || _.isUndefined(modifier.value)){
            modifiersToDisplay = []
        }else{
            modifiersToDisplay = modifier?.children?.filter((el) => {
                return utilityArray.includes(el.value.codeIdentifier_ML);
            }) || [];
        }

        if (isCompRaterFilterModifiers) {
            modifiersToDisplay = modifiersToDisplay.filter((el) => {
                return !FILTERED_LINE_MODIFIERS.includes(el.value.codeIdentifier_ML);
            })
        }

        if (isVehicleModifiers) {
            modifiersToDisplay = modifiersToDisplay.filter((el) => {
                return !connectedCarModifiers.includes(el.value.codeIdentifier_ML);
            })
        }

        return modifiersToDisplay;
    }

    const filterNonUtilityModifiers = () => {
        let modifiersToDisplay
        if (_.isEmpty(modifier.value) || _.isUndefined(modifier.value)) {
            modifiersToDisplay = []
        } else {
            modifiersToDisplay = modifier?.children?.filter((el) => {
                if (isAdditionalInfoPrebind) {
                    return !utilityArray.includes(el.value.codeIdentifier_ML) && el.value.chosenTermValue !== "false" && el.value.codeIdentifier_ML !== "PAEvaluationHomeownership_ML";
                }
                return !utilityArray.includes(el.value.codeIdentifier_ML);
            }) || [];
        }

        if (isCompRaterFilterModifiers) {
            modifiersToDisplay = modifiersToDisplay.filter((el) => {
                return !FILTERED_LINE_MODIFIERS.includes(el.value.codeIdentifier_ML);
            })
        }

        if (isVehicleModifiers) {
            modifiersToDisplay = modifiersToDisplay.filter((el) => {
                return !connectedCarModifiers.includes(el.value.codeIdentifier_ML);
            })
        }


        return modifiersToDisplay;
    }

    const getUtilityModifiers = () => {
        if (driverModifiers) {
            return [];
        }

        return !modifier ? [] : filterUtilityModifiers()
    };

    const filterOutSignalProgramFromDriverScreen = () => {
        // check if current step is edit driver and LOB is auto or comprater flow (validation screen before quote)
        if (driverPage || isCompRaterSpacing) {
            return driverModifiers.modifiers.children.filter((el) => {
                return !FILTERED_SIGNAL_FROM_DRIVER_SCREEN.includes(el.value.codeIdentifier_ML);
            });
        } else if (isPolicyChange) {
            return driverModifiers.modifiers.children;
        } else {
            return driverModifiers.modifiers.children.filter((el) => {
                return DISPLAY_SIGNAL_QUESTIONS.includes(el.value.codeIdentifier_ML);
            })
        }
    }

    const getNonUtilityModifiers = () => {
        if (driverModifiers) {
            return driverModifiers.modifiers ? filterOutSignalProgramFromDriverScreen() : driverModifiers.children;
        }
        return !modifier ? [] : filterNonUtilityModifiers()
    };

    const hasUtilityModifiers = () => {
        return getUtilityModifiers()?.length > 0;
    };

    const hasSameIDAndIsSelected = (mod, modifierID) => {
        return mod.patternCode.value === modifierID
            && mod.chosenTermValue.value === 'true';
    };

    const getModifierLabel = (mod) => {
        if (mod.isDualLabels_ML.value) {
            return `${mod.description_ML.value}${mod.name.value}`;
        }

        else if (isModernProductHOP && mod.codeIdentifier_ML?.value === "HOPHasSmokeAndFireMonitor_ML") {
            return translator(messages.labelForSmokeFire)
        }

        return mod.name.value;
    };

    const getPopoverContent = (mod) => {
        let popoverContent = '';

        if (mod.value.codeIdentifier_ML === "PAMultiplePolicyHomePolicyNumber_ML"||mod.value.codeIdentifier_ML === "PAEvaluationMultiPolicy_ML" ||mod.value.codeIdentifier_ML ==="PAMultiplePolicyRentersPolicyNumber_ML"|| mod.value.codeIdentifier_ML ==="PAMultiplePolicyCondoPolicyNumber_ML" || mod.value.codeIdentifier_ML ==="PAMultiplePolicyMobilePolicyNumber_ML"||mod.value.codeIdentifier_ML ==="PAMultiplePolicyBoatPolicyNumber_ML"||mod.value.codeIdentifier_ML ==="PAMultiplePolicyUmbrellaPolicyNumber_ML"||mod.value.codeIdentifier_ML ==="PAMulitplePolicyMotorCyclePolicyNumber_Ext"||mod.value.codeIdentifier_ML ==="PAMulitplePolicyRecreationalVehPolicyNumber_Ext"||mod.value.codeIdentifier_ML ==="PAMulitplePolicyOffRoadVehPolicyNumber_Ext"
                ||mod.value.codeIdentifier_ML === "HOPMultiPolicyNumberAuto_Ext"||mod.value.codeIdentifier_ML === "HOPAnotherPrimSeasSecPropertyPolicyNumber_Ext" || mod.value.codeIdentifier_ML === "HOPPrimSeasSecPropertyPolicyNumber_Ext" ||mod.value.codeIdentifier_ML === "HOPMultiPolicyNumberLandlord_Ext"||mod.value.codeIdentifier_ML === "HOPMultiPolicyNumberUmbrella_Ext"||mod.value.codeIdentifier_ML === "HOPMultiPolicyNumberBoat_Ext"||mod.value.codeIdentifier_ML === "HOPMultiPolicyNumberMotorcycle_Ext"||mod.value.codeIdentifier_ML === "HOPMultiPolicyNumberRecreationalVehicle_Ext"||mod.value.codeIdentifier_ML === "HOPMultiPolicyNumberOffRoadVehicle_Ext") {
            return  translator(messages.policyNumberTooltipContent)
        }
         if (isQnB && mod.value.codeIdentifier_ML === "HOPOtherMetLifeProduct_ML") {
            return translator(messages.anotherProductToolTipContentQB)
        }
         // eslint-disable-next-line no-secrets/no-secrets
         if (isQnB && mod.value.codeIdentifier_ML === "HOPElectricalYearUpdated_ML") {
            return translator(messages.electricYearToolTipContentQB)
        }

        if (mod.isDualLabels_ML && mod.isDualLabels_ML.value) {
            return popoverContent;
        }

        if (mod.description_ML.value !== mod.name.value) {
            popoverContent = mod.description_ML.value.replace(/'/g, '&apos;');
        }

        if (mod.refCode_ML && mod.refCode_ML.value) {
            const link = `#faq/${mod.refCode_ML.value}`;
            popoverContent += translator(messages.readMore, {
                a: (chunks) => <a target='_blank' rel='noreferrer' href={link}>{chunks}</a>
            });
        }

        return popoverContent === '' ? popoverContent : htmlParser(popoverContent);
    };

    const isEqualOrLessThanButtonLimit = (answersAmount) => {
        if (answersAmount === 0) {
            return false;
        }
        if (isHomeowners === true) {
            return answersAmount === MLModifierUtil.MLRatingLimits.modifierButtonLimit;
        }
        return answersAmount <= MLModifierUtil.MLRatingLimits.buttonLimit;
    };

    const isGreaterThanButtonLimit = (answersAmount) => {
        if (answersAmount === 0) {
            return false;
        }
        if (isHomeowners === true) {
            return answersAmount !== MLModifierUtil.MLRatingLimits.modifierButtonLimit;
        }
        return answersAmount > MLModifierUtil.MLRatingLimits.buttonLimit;
    };

    const setTextModifier = (value, mod) => {
        mod.chosenTermValue.value = value;
        refreshData();
    };

    const getModifierButtonCssClass = (answers) => {
        if (answers.value.length === 2) {
            return 'gw-col-phone-6 gw-col-tablet-4';
        }
        return answers.value.some((answer) => answer.name.length > MLModifierUtil.MLRatingLimits.charLimit)
            ? 'ml-long-button-group ml-mobile-button-group'
            : 'gw-col-phone-12 gw-col-tablet-landscape-2 ml-space-group-button';
    };

    const ifModError = (mod) => {
        return !mod.aspects.valid || !mod.aspects.subtreeValid;
    };

    const getCustomErrorMessage = (mod) => {
        const errorMessageDisplayKey = MLModifierUtil.getErrorMessage(mod);
        if (errorMessageDisplayKey) {
            return translator(messages[errorMessageDisplayKey]);
        }
        return undefined;
    };

    const customErrorMessageExists = (mod) => {
        return !_.isUndefined(MLModifierUtil.getErrorMessage(mod));
    };

    const showRadioErrorMessage = (mod) => {
        return _.isUndefined(mod.chosenTermValue.value) && mod.chosenTermValue.aspects.required;
    };

    const isDefaultedFieldByCodeIdentifier = (model) => {
        return !!isFieldDefaultedByHvq && isFieldDefaultedByHvq(model.codeIdentifier_ML.value);
    };

    //
    // ViewModelForm
    //
    const model = {
        utilityModifiers: getUtilityModifiers(),
        nonUtilityModifiers: getNonUtilityModifiers()
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate: onValidate
        },
        resolveClassNameMap: styles
    };
     const isOptionalPolicyNumberModifier = (mod) => {
       return !isPolicyChange && OPTIONAL_POLICY_NUMBER_MODIFIERS.includes(
         _.get(mod, "codeIdentifier_ML.value"),
       );
     };
    const generateNonUtilityModifiersOverride = () => {
        const modifiers = model.nonUtilityModifiers || [];
        const overrides = modifiers.map((mod, index, modList) => {
            const nextMod = index + 1 < modList.length ? modList[index + 1] : undefined;
            const isNextModifierTextType = nextMod ? MLModifierUtil.isTextModifier(nextMod.valueType.value) : false;
            if (mod.valueType.value === 'date' && showValidationErrors && _.isNil(dateValidationMessage)) {
                validateDateModIfShowErrors(mod);
            }
            return {
                [`modifierId${index}`]: {
                    className: isCompRaterSpacing || isNextModifierTextType ? "vertical-spacing-0" : "vertical-spacing-zero"
                },
                [`notCustomValueTypeRow${index}`]: {
                    visible: !MLModifierUtil.isCustomValueType(mod.valueType.value)
                },
                [`nonCustomValueTypeFormGroup${index}`]: {
                    visible: isGreaterThanButtonLimit(mod.options.length),
                    className: isModernProductHOP ? "dropDownStyle" : ""
                },
                [`nonCustomValueTypeSelect${index}`]: {
                    labelPosition: "top",
                    isHorizontal: "true",
                    id: `nonCustomValueTypeSelect${appendModifierId}${index}`,
                    value: mod.chosenTermValue.value,
                    label: getModifierLabel(mod),
                    availableValues: _.get(mod, 'options.value', []).map((choice) => {
                        return {
                            code: choice.code,
                            name: choice.name
                        };
                    }),
                    model: mod,
                    onValueChange: _updateModifier,
                    required: mod.chosenTermValue.aspects.required,
                    showErrors: showValidationErrors,
                    onValidate
                },
                [`nonCustomValueTypeRadioInput${index}`]: {
                    className: isCompRaterSpacing ? `${isQnB ? "flex-column-qs-qb radioButtonQnB" : "flex-column-qs"} MT-Full-Widt MT-fle jut__FieldComponent__reversed vertical-spacing_ten` : `${isQnB ? "flex-column-qs-qb radioButtonQnB" : "flex-column-qs"} MT-Full-Widt MT-fle jut__FieldComponent__reversed vertical-spacing_1_0`,
                    controlClassName: isQnB ? 'radio-button-qs horizontal-space-0-qb radioButtonQnB radioButtonPE' : 'radio-button-qs horizontal-space-5 radioButtonPE',
                    labelPosition: "top",
                    isHorizontal: "true",
                    id: `nonCustomValueTypeRadioInput${appendModifierId}${index}`,
                    value: mod.chosenTermValue.value,
                    disabled: (mod.codeIdentifier_ML?.value === "HOPWildfireMitigation_Ext")
                        && (mod.chosenTermValue?.value === "true" || mod.chosenTermValue?.value === true)
                        && mod?.isEditable_ML?.value === false,
                    availableValues: _.get(mod, 'options.value', []).map((choice) => {
                        return {
                            code: choice.code,
                            name: choice.name
                        };
                    }),
                    label: getModifierLabel(mod),
                    tooltip: {
                        text: getPopoverContent(mod),
                        placement: 'bottom',
                        className: 'tooltip-qs'
                    },
                    model: mod,
                    onValueChange: _updateModifier,
                    required: mod.chosenTermValue.aspects.required,
                    showErrors: showValidationErrors,
                    onValidate
                },
                [`phoneTextContainer${index}`]: {
                    visible: MLModifierUtil.isPhoneTextModifier(mod.valueType.value)
                },
                [`phoneTextInput${index}`]: {
                    className: isQnB ? "flex-column-qs-qb MT-Full-Widt MT-fle vertical-spacing_ten phonetext-widthQB jut__FieldComponent__reversed" : "flex-column-qs MT-Full-Widt MT-fle vertical-spacing_ten phonetext-width jut__FieldComponent__reversed",
                    value: mod.chosenTermValue.value,
                    label: getModifierLabel(mod),
                    tooltip: {
                        text: getPopoverContent(mod),
                        placement: 'bottom',
                        className: 'tooltip-qs'
                    },
                    model: mod,
                    onValueChange: onPhoneTextValueChange,
                    showErrors: showValidationErrors,
                    required: true,
                    onValidate: onValidate
                },
                [`nonCustomValueTypeFormInline${index}`]: {
                    labelPosition: "top",
                    isHorizontal: "true",
                    visible: isEqualOrLessThanButtonLimit(mod.options.length)
                },
                [`signalNotification${index}`]:{
                    visible: mod.codeIdentifier_ML.value === 'PADriverSignalProgram_Ext' && isQnB && isModernProductQB,
                    message: translator(messages.signalNotification,{
                        strong: (chunks) => <strong>{chunks}</strong>
                    })
                },

                [`textModifierContainer${index}`]: {
                    className: "vertical-spacing-0 margin-textmodifier",
                    visible: MLModifierUtil.isTextModifier(mod.valueType.value) && mod.isVisible_ML.value
                },
                [`multiPolicyHeaderContainer${index}`]: {
                    className: "margin-multiploicy-header-container",
                    visible: mod.codeIdentifier_ML.value === PA_MULTI_POLICY_CODE_IDENTIFIER || mod.codeIdentifier_ML.value === HO_MULTI_POLICY_CODE_IDENTIFIER
                },
                [`textModifier${index}`]: {
                    labelPosition: "top",
                    isHorizontal: "true",
                    model: mod,
                    value: mod.chosenTermValue.value,
                    label: getModifierLabel(mod),
                    tooltip: {
                        text: getPopoverContent(mod),
                        placement: 'bottom',
                        className: 'tooltip-qs'
                    },
                    onValueChange: setTextModifier,
                    onBlur: updateTextModifier,
                    required: isOptionalPolicyNumberModifier(mod) ? false : mod.chosenTermValue.aspects.required,
                    validationMessages: isOptionalPolicyNumberModifier(mod) ? [] : mod.chosenTermValue.aspects.validationMessages,
                    showErrors: showValidationErrors,
                    className: isQnB ? "textModifierInput ml-popover__container ml-popover-basic pointer-left clearfix flex-column-qs-qb MT-Full-Widt MT-fle jut__FieldComponent__reversed vertcal-spacing-0" : "textModifierInput ml-popover__container ml-popover-basic pointer-left clearfix flex-column-qs MT-Full-Widt MT-fle jut__FieldComponent__reversed vertcal-spacing-0"
                },
                [`stateModifierContainer${index}`]: {
                    visible: MLModifierUtil.isStateModifier(mod.valueType.value)
                },
                [`stateModifier${index}`]: {
                    className: isQnB? "flex-column-qs-qb MT-Full-Widt MT-fle jut__FieldComponent__reversed vertical-spacing_2_5" :  "flex-column-qs MT-Full-Widt MT-fle jut__FieldComponent__reversed vertical-spacing_2_5",
                    id: `stateModifier${appendModifierId}${index}`,
                    value: mod.chosenTermValue.value,
                    label: getModifierLabel(mod),
                    availableValues: _.get(mod, 'options.value', []).map((choice) => {
                        return {
                            code: choice.code,
                            name: choice.name
                        };
                    }),
                    model: mod,
                    onValueChange: _updateModifier,
                    validationMessages: mod.chosenTermValue.aspects.validationMessages,
                    showErrors: showValidationErrors
                },
                [`dateModifierContainer${index}`]: {
                    visible: (!isModernProductHOP && !isFullDateModifier(mod)) && mod.valueType.value === 'date' && !isMonthYearModifier(mod),
                },
                [`dateModifier${index}`]: {
                    className: isQnB ? "flex-column-qs-qb MT-Full-Widt MT-fle vertical-spacing-11 jut__FieldComponent__reversed" : "flex-column-qs MT-Full-Widt MT-fle vertical-spacing-11 jut__FieldComponent__reversed",
                    model: mod,
                    label: getModifierLabel(mod),
                    showErrors: showValidationErrors,
                    onValueChange: onDateTextValueChange,
                    validationMessages: !_.isNil(dateValidationMessage) ? [dateValidationMessage] : mod.dateValue_ML.aspects.validationMessages,
                    value: datetoStringDate(_.get(mod, 'dateValue_ML.value')),
                    tooltip: {
                        text: getPopoverContent(mod),
                        placement: 'bottom',
                        className: 'tooltip-qs'
                    },
                    required: mod.chosenTermValue.aspects.required,
                },
                [`fullDateModifierContainer${index}`]: {
                    visible: isModernProductHOP && isFullDateModifier(mod) && mod.valueType.value === 'date',
                },
                [`fullDateModifier${index}`]: {
                    model: mod,
                    label: getModifierLabel(mod),
                    showErrors: showValidationErrors,
                    onValueChange: (value) => {
                        if (_.isUndefined(value) || _.isNull(value)) {
                            _updateModifier(undefined, mod);
                            return;
                        }
                        const dateValue = value instanceof Date
                            ? {
                                year: value.getFullYear(),
                                month: value.getMonth() + 1,
                                day: value.getDate()
                            }
                            : value;
                        if (!dateValue?.year || !dateValue?.month || !dateValue?.day) return;
                        const currentValue = _.get(mod, 'dateValue_ML.value');
                        if (_.isEqual(currentValue, dateValue)) return;
                        _updateModifier(dateValue, mod);
                    },
                    value: _.get(mod, 'dateValue_ML.value'),
                    tooltip: {
                        text: getPopoverContent(mod),
                        placement: 'bottom',
                        className: 'tooltip-qs'
                    },
                    required: mod.chosenTermValue.aspects.required,
                },
                [`monthYearModifier${index}`]: {
                    className: isQnB? "flex-column-qs-qb MT-Full-Widt MT-fle jut__FieldComponent__reversed vertical-spacing-15" : "flex-column-qs MT-Full-Widt MT-fle jut__FieldComponent__reversed vertical-spacing-15",
                    visible: mod.valueType.value === 'date' && isMonthYearModifier(mod),
                    label: getModifierLabel(mod),
                    showErrors: showValidationErrors || getDateValidationMessage,
                    onValueChange: onDateTextValueChange,
                    validationMessages: !_.isNil(dateValidationMessage) ? [dateValidationMessage] : mod.dateValue_ML.aspects.validationMessages,
                    value: datetoStringDate(_.get(mod, 'dateValue_ML.value')),
                    path: mod,
                    tooltip: {
                        text: getPopoverContent(mod),
                        placement: 'bottom',
                        className: 'tooltip-qs'
                    }
                },
                [`modifierWarning${index}`]: {
                    visible: isDefaultedFieldByCodeIdentifier(mod)
                }
            };
        });

        return Object.assign({}, ...overrides);
    };

    const generateUtilityModifiersOverride = () => {
        const modifiers = model.utilityModifiers || [];
        const overrides = modifiers.map((mod, index) => {
            if (mod.valueType.value === 'date' && showValidationErrors && _.isNil(dateValidationMessage)) {
                validateDateModIfShowErrors(mod);
            }
            return {
                [`homeDateModifier${index}`]: {
                    visible: mod.valueType.value === 'date',
                    label: mod.name.value,
                    onValueChange: onDateTextValueChange,
                    validationMessages: !_.isNil(dateValidationMessage) && !mod.dateValue_ML.aspects.subtreeValid && _.isEmpty(mod.dateValue_ML.aspects.validationMessages) ? [dateValidationMessage] : mod.dateValue_ML.aspects.validationMessages,
                    value: datetoStringDate(_.get(mod, 'dateValue_ML.value')),
                    showErrors: showValidationErrors,
                    path: mod,
                    tooltip: {
                        text: getPopoverContent(mod),
                        placement: 'bottom',
                        className: 'tooltip-qs'
                    }
                }
            };
        });

        return Object.assign({}, ...overrides);
    };

    const handleValueChange = (value, path) => {
        _.set(submissionVM, path, value);
        refreshData();
        updateWizardData(submissionVM);
    }

    const overrides = {
        MLModifierContainer: {
            className: isQnB ? "vertical-spacing-0 widthQB": "vertical-spacing-0"
        },
        nonUtilityModifiersIterable: {
            className: 'vertical-spacing-20',
            data: model.nonUtilityModifiers,
            onchange: handleOnChange ? handleValueChange : undefined
        },
        utilityModifiersIterable: {
            data: model.utilityModifiers
        },
        homeModifiersContainer: {
            visible: hasUtilityModifiers()
        },
        ...generateNonUtilityModifiersOverride(),
        ...generateUtilityModifiersOverride()
    };

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            {...resolvers} />
    );
}

MLModifierComponent.propTypes = {
    modifier: PropTypes.shape({
        children: PropTypes.arrayOf(PropTypes.shape({}))
    }),
    driverModifiers: PropTypes.shape({
        children: PropTypes.arrayOf(PropTypes.shape({})),
        modifiers: PropTypes.shape({
            children: PropTypes.arrayOf(PropTypes.shape({}))
        })
    }),
    updateModifier: PropTypes.func,
    isHomeowners: PropTypes.bool,
    isCompRaterSpacing: PropTypes.bool,
    isFieldDefaultedByHvq: PropTypes.func,
    handleModifierModelChange: PropTypes.func,
    showValidationErrors: PropTypes.bool,
    onValidate: PropTypes.func,
    modifierIdToAppend: PropTypes.string,
    updateWizardData: PropTypes.func,
    handleOnChange: PropTypes.bool,
};

MLModifierComponent.defaultProps = {
    modifier: undefined,
    driverModifiers: undefined,
    updateModifier: undefined,
    isHomeowners: false,
    isCompRaterSpacing: false,
    isFieldDefaultedByHvq: undefined,
    handleModifierModelChange: undefined,
    showValidationErrors: false,
    onValidate: undefined,
    modifierIdToAppend: undefined,
    isCompRaterFilterModifiers: false,
    updateWizardData: (value) => { },
    handleOnChange: false,
};

export default MLModifierComponent;